var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from 'react';
import { routes } from '@lean-body/src/route';
import { LocalStorage, SessionStorage } from '@lean-body/src/infra';
import { MAX_DATE_TIMESTAMP, convertToSeconds, exceedWeek, isAndroidApp } from '@lean-body/src/util';
import { ReleaseNotificationModal, TwitterFormDialog } from '../molecules';
import { useNavigate } from 'react-router-dom';
import { SettingItemKeys } from './setting_menu';
import { MealTaskNotificationRequestDialog } from '../molecules/meal_task_notification_permission_dialog';
import { MealTaskAboutDialog } from '../molecules/meal_task_about_dialog';
import { MealAIInputAboutDialog } from '../molecules/meal_ai_input_about_dialog';
import { StreakFreezeUsedYesterdayModal } from '../molecules/streak_freeze_used_yesterday_modal';
import { BeginnerMissionModal } from './beginner_mission_modal';
export const HomeDialogGroup = ({ isMealTaskAboutDialogOpen, isMealAIInputAboutDialogOpen, releaseNotificationDialog, twitterService, currentStreak, onCloseMealTaskAboutDialog, onSuccessMealTaskAboutDialog, beginnerMission, isBeginnerMissionDialogOpen, onCloseBeginnerMissionDialog, }) => {
    const navigate = useNavigate();
    const localStorage = new LocalStorage();
    const sessionStorage = new SessionStorage();
    const androidUIDismissals = localStorage.loadAndroidNotificationPermissionRequestUIDismissals();
    const [showTwitterFormDialog, setShowTwitterFormDialog] = React.useState(false);
    const [showNewReleaseNotificationDialog, setShowNewReleaseNotificationDialog] = React.useState((releaseNotificationDialog === null || releaseNotificationDialog === void 0 ? void 0 : releaseNotificationDialog.id) > localStorage.loadHomeDialogId);
    const [showMealTaskNotificationRequestDialog, setShowMealTaskNotificationRequestDialog] = React.useState(false);
    const [showStreakFreezeUsedYesterdayModal, setShowStreakFreezeUsedYesterdayModal] = React.useState(false);
    const [isInitialized, setIsInitialized] = React.useState(false);
    React.useEffect(() => {
        var _a;
        setIsInitialized(true);
        // Twitter(X)ダイアログ
        setShowTwitterFormDialog(twitterService.showFormDialog);
        twitterService.showFormDialog = false;
        if ((currentStreak === null || currentStreak === void 0 ? void 0 : currentStreak.isUsedFreezeYesterday) && !localStorage.noticedStreakFreezeUsedYesterdayModalToday) {
            setShowStreakFreezeUsedYesterdayModal(true);
        }
        // 食事通知許可ダイアログ
        if (localStorage.loadShowMealTaskNotificationPermissionDialog) {
            // 食事記録をした直後のみ表示したいので、すぐ無効にする
            localStorage.saveShowMealTaskNotificationPermissionDialog(false);
            if (isAndroidApp()) {
                /*
                  以下の条件で食事入力忘れプッシュ通知許諾を求めるダイアログを表示する
                    1. 端末の通知設定がOFFになっている、もしくは食事入力忘れ通知がOFFになっている
                    2. ダイアログを表示したことない
                */
                const hasNotificationPermission = sessionStorage.loadAndroidDeviceNotificationPermission();
                const useMealTaskNotifications = ((_a = sessionStorage.loadAndroidNotificationSettings()) === null || _a === void 0 ? void 0 : _a.mealTaskRemindAt) !== '';
                if (hasNotificationPermission && useMealTaskNotifications) {
                    return;
                }
                if (androidUIDismissals.mealTaskDialog === false || exceedWeek(androidUIDismissals.mealTaskDialog)) {
                    setShowMealTaskNotificationRequestDialog(true);
                }
            }
        }
    }, []);
    const onCloseReleaseNotificationDialog = () => {
        localStorage.saveHomeDialogId(releaseNotificationDialog.id);
        setShowNewReleaseNotificationDialog(false);
    };
    const onClickTwitterPost = (text, file) => __awaiter(void 0, void 0, void 0, function* () {
        twitterService.postTweet(text, file).finally(() => {
            setShowTwitterFormDialog(false);
        });
    });
    const onClickTwitterPostCancel = () => {
        setShowTwitterFormDialog(false);
    };
    const onClickMealTaskNotificationPermissionDialog = (isDontShowAgain) => {
        androidUIDismissals.mealTaskDialog = isDontShowAgain ? MAX_DATE_TIMESTAMP : Date.now();
        localStorage.setAndroidNotificationPermissionRequestUIDismissals(androidUIDismissals);
        navigate(`${routes.SETTING.compile()}?key=${SettingItemKeys.notification}`);
    };
    const onCloseMealTaskNotificationPermissionDialog = (isDontShowAgain) => {
        androidUIDismissals.mealTaskDialog = isDontShowAgain ? MAX_DATE_TIMESTAMP : Date.now();
        localStorage.setAndroidNotificationPermissionRequestUIDismissals(androidUIDismissals);
        setShowMealTaskNotificationRequestDialog(false);
    };
    const onClickMealTaskAboutDialogCancel = () => {
        onCloseMealTaskAboutDialog && onCloseMealTaskAboutDialog();
    };
    const onClickMealTaskAboutDialogSuccess = () => {
        onSuccessMealTaskAboutDialog && onSuccessMealTaskAboutDialog();
    };
    const onCloseStreakFreezeUsedYesterdayModal = () => {
        localStorage.saveStreakFreezeUsedYesterdayModalDisplayedAt(convertToSeconds(Date.now()));
        setShowStreakFreezeUsedYesterdayModal(false);
    };
    if (!isInitialized)
        return null;
    const shouldShowBeginnerMissionDialog = isBeginnerMissionDialogOpen && beginnerMission && !isMealTaskAboutDialogOpen && !isMealAIInputAboutDialogOpen;
    return (React.createElement(React.Fragment, null, showStreakFreezeUsedYesterdayModal ? (React.createElement(StreakFreezeUsedYesterdayModal, { streakCount: currentStreak.streakCount, onClickCancel: onCloseStreakFreezeUsedYesterdayModal })) : shouldShowBeginnerMissionDialog ? (React.createElement(BeginnerMissionModal, { mission: beginnerMission, onClose: onCloseBeginnerMissionDialog })) : showNewReleaseNotificationDialog ? (React.createElement(ReleaseNotificationModal, { close: onCloseReleaseNotificationDialog, dialog: releaseNotificationDialog })) : showTwitterFormDialog ? (React.createElement(TwitterFormDialog, { imageURL: twitterService.tweetImgSrc, centerImageWidth: twitterService.tweetCenterImageWidth, defaultText: twitterService.tweetDefaultText, onClickCancel: onClickTwitterPostCancel, submit: onClickTwitterPost })) : showMealTaskNotificationRequestDialog ? (React.createElement(MealTaskNotificationRequestDialog, { onClickSuccess: onClickMealTaskNotificationPermissionDialog, onClickCancel: onCloseMealTaskNotificationPermissionDialog })) : isMealTaskAboutDialogOpen ? (React.createElement(MealTaskAboutDialog, { onClickCancel: onClickMealTaskAboutDialogCancel, onClickSuccess: onClickMealTaskAboutDialogSuccess })) : isMealAIInputAboutDialogOpen ? (React.createElement(MealAIInputAboutDialog, { onClickCancel: onClickMealTaskAboutDialogCancel, onClickSuccess: onClickMealTaskAboutDialogSuccess })) : null));
};
